import React, { useContext } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useMediaQuery, useTheme } from "@mui/material";
import ToolbarMenu from "./ToolbarMenu";
import ConnectionMonitor from "./ConnectionMonitor";
import { APPLICATION_VERSION } from "../App";
import DateNavigator from "./DateNavigator";
import { GlobalContext } from "../Utils/Contexts";

interface TicketAppBarProps {
    setAuthorizationToken(newToken: string | null): void;
    setPersonId(newPersonId: string | null): void;
}

export default function TicketAppBar(props: TicketAppBarProps): JSX.Element {
    const context = useContext(GlobalContext);
    const theme = useTheme();
    const showNameAndVersion = useMediaQuery(theme.breakpoints.up("md"));
    const titleText = (showNameAndVersion ? "PILOT DUTY " : "") + APPLICATION_VERSION;

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static">
                <Toolbar>
                    <Typography>{titleText}</Typography>
                    <Typography component="div" sx={{ flexGrow: 1 }} />
                    {<DateNavigator />}
                    <Typography component="div" sx={{ flexGrow: 1 }} />
                    <ConnectionMonitor />
                    <ToolbarMenu setAuthorizationToken={props.setAuthorizationToken} setPersonId={props.setPersonId}></ToolbarMenu>
                </Toolbar>
            </AppBar>
        </Box>
    );
}
